import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import automationBlocks from "../commons/automationBlocks";

export const automationDesignStore = new Vuex.Store({
    state: {
        form: null,
        diagram: null,
        debugPayload: null,
        variables: [
            { name: 'Entry' },
            { name: 'Form' },
        ],
        plugins: null,
        // Latest api/CanvasTest/SyncTriggers verdict for the OPEN activity design, published by
        // FTSFormDesigner's debounced refresh. The D-8 surfaces (Start-node "Syncs on" list,
        // logic-action + backendScript declaration rows) derive the effective combined trigger
        // set from this — never a client-side re-derivation.
        syncVerdict: null,
    },
    mutations: {
        setDiagram(state, data) {
            state.diagram = data;
        },
        setSyncVerdict(state, data) {
            state.syncVerdict = data;
        },
        setForm(state, data) {
            state.form = data;
        },
        setDebugPayload(state, data) {
            state.debugPayload = data;
        },
        setPlugins(state, data) {
            state.plugins = data;
        }
    },
    actions: {
        async loadPlugins({ commit, dispatch }, payload) {
            commit('setPlugins', payload);
        },
        async loadDiagram({ commit, dispatch }, payload) {
            commit('setDiagram', payload);
            dispatch('updateVariables');
        },
        async loadForm({ commit, dispatch }, payload) {
            commit('setForm', payload);
            dispatch('updateVariables');
        },
        async debugPayload({ commit, dispatch }, payload) {
            commit('setDebugPayload', payload);
        },
        async updateVariables({ state, commit }, payload) {
            var formWithRows = null;

            if (state.form) {
                formWithRows = {
                    rows: state.form.rows
                }
            }

            automationBlocks.computeVariables(state.diagram, formWithRows);
            window.eventBus.$emit("refreshAutomationBlocks");
        },
    }
})